import { useMemo } from 'react';
import { SCORING_FORMS_LOCALHOST } from 'src/constants';

export const LocalhostScoringForm = () => {
  const token = useMemo(() => {
    return JSON.parse(
      Object.values(localStorage).find(value => value.includes('id_token'))
    ).id_token;
  }, []);

  return (
    <iframe
      className='w-screen h-screen'
      src={`${SCORING_FORMS_LOCALHOST}?iframetoken=${token}`}
    />
  );
};
